const defaultSetup = {
  bgConfig: {
    className: "bg-blue-500/20 p-2 rounded",
  },
  valueConfig: {
    system: "US", // US, IN
    decimals: 0, //
    format: "", // optional: 'compact' for 1K, 1M//
  },
  layoutConfig: {
    layoutClassName: "",
    titleClassName: "",
    valueClassName: "",
    descriptionClassName: "",
  },
};

const overlayStylesDefault = {
  smoothOpacity:
    "absolute inset-0 bg-black/10 opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100",
  fromBottom:
    "absolute inset-0 bg-black/10 translate-y-full transition-transform duration-400 ease-out group-hover:translate-y-0",
  fromLeft:
    "absolute inset-0 bg-black/20 -translate-x-full transition-transform duration-500 ease-out group-hover:translate-x-0 ",
  circleReveal:
    "absolute inset-0 bg-black/40 rounded-full scale-0 transition-transform duration-500 ease-out group-hover:scale-150",
  diagonalReveal:
    "absolute inset-0 bg-black/40 origin-top-left scale-x-0 scale-y-0 transition-transform duration-500 ease-out group-hover:scale-100",
  rotateScaleAnimation:
    "absolute inset-0 opacity-0 bg-black/20 scale-0 rotate-45 transition-all duration-500 ease-out group-hover:scale-150 group-hover:opacity-100 group-hover:rotate-0",
  blurGlassOverlay:
    "absolute inset-0 backdrop-blur-md bg-white/50 opacity-0 transition-all duration-300 ease-out group-hover:opacity-70",
  radialGradientExplosion:
    "absolute inset-0 bg-[radial-gradient(circle,rgba(0,0,0,0.6)_0%,rgba(0,0,0,0.2)_40%,transparent_70%)] scale-0 transition-transform duration-500 group-hover:scale-150",
};

const layoutStylesDefault = {
  option1: {
    titleConfig: {
      tag: "p",
      className: "text-[14px] leading-[20px]",
    },
    valueConfig: {
      className: "text-[36px] font-semibold",
    },
    prefixConfig: {
      className: "text-[36px] font-semibold",
    },
    suffixConfig: {
      className: "text-[36px] font-semibold",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-5",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary",
      className: "text-[15px]! text-primary",
    },
    bgConfig: {
      className:
        "p-3 bg-gradient-to-b from-gray-200 to-white rounded shadow relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-3",
      titleClassName: "",
      valueClassName: "flex justify-between items-center gap-3",
    },
  },
  option2: {
    titleConfig: {
      tag: "p",
      className: "text-[16px] leading-[22px]",
    },
    valueConfig: {
      className: "text-[18px] leading-[22px] font-semibold",
    },
    prefixConfig: {
      className: "text-[18px] leading-[22px] font-semibold",
    },
    suffixConfig: {
      className: "text-[18px] leading-[22px] font-semibold",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary",
      className: "text-[13px]! text-primary",
    },
    bgConfig: {
      className:
        "p-3 bg-gradient-to-b from-gray-200 to-white rounded shadow  relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex justify-between items-center gap-2",
      titleClassName: "flex justify-between items-center gap-3",
      valueClassName: "flex items-center gap-1",
    },
  },
  option3: {
    titleConfig: {
      tag: "p",
      className: "text-[16px] leading-[22px]",
    },
    valueConfig: {
      className: "text-[22px] leading-[26px] font-semibold text-primary",
    },
    prefixConfig: {
      className: "text-[22px] leading-[26px] font-semibold text-primary",
    },
    suffixConfig: {
      className: "text-[22px] leading-[26px] font-semibold text-primary",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary",
      className: "text-[13px]! text-primary",
    },
    bgConfig: {
      className:
        "px-3 py-2 bg-white rounded shadow border border-gray-200 relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex justify-between items-center gap-4",
      titleClassName: "flex justify-between items-center gap-3",
      valueClassName: "flex items-center gap-1",
    },
  },
  option4: {
    titleConfig: {
      tag: "p",
      className: "text-[12px] leading-[16px]",
    },
    valueConfig: {
      className: "text-[20px] leading-[24px] font-semibold text-primary",
    },
    prefixConfig: {
      className: "text-[20px] leading-[24px] font-semibold text-primary",
    },
    suffixConfig: {
      className: "text-[16px] leading-[22px] font-semibold text-primary",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary",
      className: "text-[13px]! text-primary",
    },
    bgConfig: {
      className:
        "px-3 py-1.5 bg-white rounded shadow border border-gray-200 relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-1",
      titleClassName: "flex justify-start items-center gap-3",
      valueClassName: "flex items-center gap-1",
    },
  },
  option5: {
    titleConfig: {
      tag: "p",
      className: "text-[12px] leading-[16px]",
    },
    valueConfig: {
      className: "text-[20px] leading-[24px] font-semibold text-primary",
    },
    prefixConfig: {
      className: "text-[20px] leading-[24px] font-semibold text-primary",
    },
    suffixConfig: {
      className: "text-[20px] leading-[24px] font-semibold text-primary",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20! text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary",
      className: "text-[13px]! text-primary",
    },
    bgConfig: {
      className:
        "px-3 py-2 bg-white rounded shadow border border-gray-200 relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col items-center gap-1",
      titleClassName: "flex justify-start items-center gap-3",
      valueClassName: "flex items-center gap-1",
    },
  },
  option6: {
    titleConfig: {
      tag: "p",
      className: "text-[12px] leading-[16px] text-primary",
    },
    valueConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-primary",
    },
    prefixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-primary",
    },
    suffixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-primary",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20! text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName: "rounded-full flex items-center justify-start",
      className: "text-[15px]! text-primary",
    },
    bgConfig: {
      className:
        "bg-primary-50 rounded shadow border border-gray-200 relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex justify-between items-center px-3 py-2",
      titleClassName: "flex flex-col justify-start gap-1",
      valueClassName: "flex items-center justify-end gap-1",
    },
  },
  option7: {
    titleConfig: {
      tag: "p",
      className: "text-[14px] leading-[20px] text-white",
    },
    valueConfig: {
      className: "text-[24px] leading-[28px] font-semibold text-primary",
    },
    prefixConfig: {
      className: "text-[24px] leading-[28px] font-semibold text-primary",
    },
    suffixConfig: {
      className: "text-[24px] leading-[28px] font-semibold  text-primary",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-1 ml-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-white",
      className: "text-[15px]! text-white",
    },
    bgConfig: {
      className:
        "bg-white rounded-lg shadow border border-gray-300! relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col justify-center shadow-lg",
      titleClassName:
        "flex gap-3 items-center justify-center flex-1 w-full bg-primary py-1 rounded-t-lg",
      valueClassName: "flex items-center justify-center py-3 px-2.5",
    },
  },
  option8: {
    titleConfig: {
      tag: "p",
      className: "text-[14px] leading-[20px] text-primary",
    },
    valueConfig: {
      className: "text-[36px] leading-[42px] font-semibold text-black",
    },
    prefixConfig: {
      className: "text-[36px] leading-[42px] font-semibold text-black",
    },
    suffixConfig: {
      className: "text-[36px] leading-[42px] font-semibold  text-black",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-1 ml-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-white/90 border border-gray-300",
      className: "text-[15px]! text-black",
    },
    bgConfig: {
      className:
        "bg-white rounded-xl! shadow-lg relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col justify-center",
      titleClassName:
        "flex gap-3 items-center justify-start flex-1 w-full bg-primary-50 p-2 rounded-t-xl",
      valueClassName: "flex items-center justify-center py-3",
    },
  },
  option9: {
    titleConfig: {
      tag: "p",
      className: "text-[20px] leading-[28px] text-white",
    },
    valueConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    prefixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    suffixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-white! text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-white",
      className: "text-[15px]! text-white",
    },
    bgConfig: {
      className:
        "px-6 py-3 bg-gradient-to-r from-[#FF781F] via-[#FF781F] via-[60%] to-[#FFC59E] border border-gray-200 rounded-2xl shadow-[inset_0_4px_6px_rgba(0,0,0,0.222)] relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-2.5",
      titleClassName: "flex justify-start items-center gap-3",
      valueClassName: "flex items-center gap-2",
    },
  },
  option10: {
    titleConfig: {
      tag: "p",
      className: "text-[20px] leading-[28px] text-black",
    },
    valueConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-primary-700",
    },
    prefixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-primary-700",
    },
    suffixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-primary-700",
    },
    descriptionConfig: {
      className: "text-[16px] leading-[22px] font-semibold text-primary-500",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-white! text-success",
      wrapperClassName: "-mt-1 ml-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary-700",
      className: "text-[15px]! text-primary-700",
    },
    bgConfig: {
      className:
        "bg-primary-50 rounded shadow border border-primary-200 rounded-2xl! relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-2.5 p-5",
      valueClassName: "flex items-center",
      titleClassName: "flex items-center gap-3",
    },
  },
  option11: {
    titleConfig: {
      tag: "p",
      className: "text-[12px] leading-[16px] text-white",
    },
    valueConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    prefixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    suffixConfig: {
      className: "text-[28px] leading-[34px] font-semibold  text-white",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-white text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName: "flex items-center justify-center",
      className: "text-[15px]! text-white p-0!",
    },
    bgConfig: {
      className:
        "bg-gradient-to-r from-[#135058] via-[#135058] via-[20%] to-[#A8A896]  rounded-md shadow-lg relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-1.5 py-2 px-3",
      titleClassName: "flex items-center justify-start gap-3",
      valueClassName: "flex items-center gap-2",
    },
  },
  option12: {
    titleConfig: {
      tag: "p",
      className: "text-[16px] leading-[20px]",
    },
    valueConfig: {
      className: "text-[16px] font-semibold leading-none text-primary",
    },
    prefixConfig: {
      className: "text-[16px] font-semibold leading-none text-primary",
    },
    suffixConfig: {
      className: "text-[16px] font-semibold leading-none text-primary",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-success/20 text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-primary",
      className: "text-[15px]! text-primary",
    },
    bgConfig: {
      className:
        "p-2 bg-white rounded shadow border border-gray-200 relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-2",
      valueClassName: "",
    },
  },
  option13: {
    titleConfig: {
      tag: "p",
      className: "text-[16px] leading-[28px] text-white",
    },
    valueConfig: {
      className: "text-[24px] leading-[34px] font-semibold text-white",
    },
    prefixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    suffixConfig: {
      className: "text-[28px] leading-[34px] font-semibold text-white",
    },
    backValueConfig: {
      className: "text-[11px] px-1 py-0.5 rounded bg-white! text-success",
      wrapperClassName: "-mt-1",
    },
    iconConfig: {
      wrapperClassName:
        "w-8 h-8 rounded-full flex items-center justify-center bg-primary/10 border border-white",
      className: "text-[15px]! text-white",
    },
    bgConfig: {
      className:
        "px-2 py-1 bg-primary border border-gray-200 rounded-md relative overflow-hidden group",
    },
    overlayConfig: {
      className: overlayStylesDefault.fromLeft,
    },
    layoutConfig: {
      layoutClassName: "flex flex-col gap-0",
      titleClassName: "flex justify-start items-center gap-1",
      valueClassName: "flex items-center gap-2",
    },
  },
};

const mergeKpiConfigs = (optionKey, setup = {}) => {
  const defaults = layoutStylesDefault[optionKey] || {};
  const {
    titleConfig = {},
    valueConfig = {},
    prefixConfig = {},
    suffixConfig = {},
    descriptionConfig = {},
    backValueConfig = {},
    iconConfig = {},
    bgConfig = {},
    overlayConfig = {},
    layoutConfig = {},
  } = setup;

  const mergedTitleConfig = {
    ...(defaults.titleConfig || {}),
    ...titleConfig,
    className: [defaults.titleConfig?.className, titleConfig.className]
      .filter(Boolean)
      .join(" "),
  };

  const mergedValueConfig = {
    ...(defaults.valueConfig || {}),
    ...valueConfig,
    system: valueConfig.system || defaultSetup.valueConfig.system,
    decimals: valueConfig.decimals || defaultSetup.valueConfig.decimals,
    format: valueConfig.format || defaultSetup.valueConfig.format,
    className: [defaults.valueConfig?.className, valueConfig.className]
      .filter(Boolean)
      .join(" "),
  };

  const mergedPrefixConfig = {
    ...(defaults.prefixConfig || {}),
    ...prefixConfig,
    className: [defaults.prefixConfig?.className, prefixConfig.className]
      .filter(Boolean)
      .join(" "),
  };
  const mergedSuffixConfig = {
    ...(defaults.suffixConfig || {}),
    ...suffixConfig,
    className: [defaults.suffixConfig?.className, suffixConfig.className]
      .filter(Boolean)
      .join(" "),
  };
  const mergedDescriptionConfig = {
    ...(defaults.descriptionConfig || {}),
    ...descriptionConfig,
    className: [
      defaults.descriptionConfig?.className,
      descriptionConfig.className,
    ]
      .filter(Boolean)
      .join(" "),
  };
  const mergedBackValueConfig = {
    ...(defaults.backValueConfig || {}),
    ...backValueConfig,
    className: [defaults.backValueConfig?.className, backValueConfig.className]
      .filter(Boolean)
      .join(" "),
    wrapperClassName: [
      defaults.backValueConfig?.wrapperClassName,
      backValueConfig.wrapperClassName,
    ]
      .filter(Boolean)
      .join(" "),
  };

  const mergedIconConfig = {
    ...(defaults.iconConfig || {}),
    ...iconConfig,
    className: [defaults.iconConfig?.className, iconConfig.className]
      .filter(Boolean)
      .join(" "),
  };

  const mergedBgConfig = {
    ...(defaults.bgConfig || {}),
    ...bgConfig,
    className: [defaults.bgConfig?.className, bgConfig.className]
      .filter(Boolean)
      .join(" "),
    wrapperClassName: [
      defaults.bgConfig?.wrapperClassName,
      bgConfig.wrapperClassName,
    ]
      .filter(Boolean)
      .join(" "),
  };

  const mergedOverlayConfig = {
    ...(defaults.overlayConfig || {}),
    ...overlayConfig,
    className: [defaults.overlayConfig?.className, overlayConfig.className]
      .filter(Boolean)
      .join(" "),
  };

  const mergedLayoutConfig = {
    ...(defaults.layoutConfig || {}),
    ...layoutConfig,
    layoutClassName: [
      defaults.layoutConfig?.layoutClassName,
      layoutConfig.layoutClassName,
    ]
      .filter(Boolean)
      .join(" "),
    titleClassName: [
      defaults.layoutConfig?.titleClassName,
      layoutConfig.titleClassName,
    ]
      .filter(Boolean)
      .join(" "),
    valueClassName: [
      defaults.layoutConfig?.valueClassName,
      layoutConfig.valueClassName,
    ]
      .filter(Boolean)
      .join(" "),
    descriptionClassName: [
      defaults.layoutConfig?.descriptionClassName,
      layoutConfig.descriptionClassName,
    ]
      .filter(Boolean)
      .join(" "),
  };

  return {
    titleConfig: mergedTitleConfig,
    valueConfig: mergedValueConfig,
    prefixConfig: mergedPrefixConfig,
    suffixConfig: mergedSuffixConfig,
    descriptionConfig: mergedDescriptionConfig,
    backValueConfig: mergedBackValueConfig,
    iconConfig: mergedIconConfig,
    bgConfig: mergedBgConfig,
    overlayConfig: mergedOverlayConfig,
    layoutConfig: mergedLayoutConfig,
  };
};

export { defaultSetup, layoutStylesDefault, mergeKpiConfigs };
